
const toastTypes = {
    error: 'error',
    warn: 'warning',
    info: 'info',
    success: 'success'
};

export default toastTypes;